import React, {
  memo,
  useEffect,
  useState,
  useContext,
  useMemo,
  useCallback
} from "react";
import moment from "moment";
import ReturnProcess from "../forms/ReturnProcess";
import { useDispatch, useSelector } from "react-redux";
import { selectAllReturnLocations } from "../store/return-process/slice";
import { doCreate, doGetList, doUpdate } from "../store/return-process/thunks";
import { setSuccessMessage } from "app/global/slice";
import profileApi from "modules/client/profile/store/api";
import { setError } from "app/global/slice";
import { ProfileContext } from "layouts/private/ProfileContext";
import "./SettingsPage.scss";

const initialData = {
  enabled: true,
  start: moment("00:00", "HH:mm"),
  end: moment("23:59", "HH:mm"),
  duration: 10,
  phoneList: [{ type: "contact", phone: "" }]
};

const RouteOptionsPage = () => {
  const [returnLocation, setReturnLocation] = useState(initialData);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.global.isLoading);
  const returnLocations = useSelector(selectAllReturnLocations);
  const profileCtx = useContext(ProfileContext);
  const profile = useMemo(() => profileCtx?.profile, [profileCtx]);
  const setProfile = useMemo(() => profileCtx?.setProfile, [profileCtx]);

  useEffect(() => {
    dispatch(doGetList());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (returnLocations?.length) {
      setReturnLocation(returnLocations[0]);
    }
  }, [returnLocations]);

  const handleOnFinish = useCallback(
    async (data) => {
      try {
        // Update routing preferences (preferredNoOfStops) if it has changed
        if (
          data.preferredNoOfStops !== undefined &&
          data.preferredNoOfStops !== profile?.client?.preferredNoOfStops
        ) {
          const updatedProfile = await profileApi.updateRoutingPreferences({
            preferredNoOfStops: data.preferredNoOfStops
          });
          setProfile({ ...profile, ...updatedProfile });
        }

        // Update return process settings
        // If return location exists, we can update it (including toggle switches)
        // If it doesn't exist, we need all required fields to create it
        if (returnLocation?.id) {
          // Updating existing return location - allow partial updates
          const { error } = await dispatch(doUpdate({ ...data, id: returnLocation.id }));
          if (error) {
            throw new Error("Failed to update return process");
          }
        } else if (data.address && data.lng && data.lat) {
          // Creating new return location - need all required fields
          const { error } = await dispatch(doCreate(data));
          if (error) {
            throw new Error("Failed to create return process");
          }
        }

        dispatch(setSuccessMessage("Updated successfully!"));
      } catch (err) {
        const error = JSON.parse(err?.message || "{}");
        dispatch(setError(error?.message || "Failed to update settings"));
      }
    },
    [dispatch, returnLocation, profile, setProfile]
  );

  return (
    <ReturnProcess
      isLoading={isLoading}
      returnLocation={returnLocation}
      profile={profile}
      onSubmit={handleOnFinish}
    />
  );
};

export default memo(RouteOptionsPage);
